/**
 * TOPページお知らせ読み込み
 */

export function loadNews(): void {
  const target = $('.js-news');
  if (!target.length) return;

  $.ajax({
    url: location.origin + '/wp-json/wp/v2/news?_fields=id,title,link,acf&order=asc&per_page=100',
  })
    .done((data) => {
      displayData(data, target);
    })
    .fail((jqXHR, textStatus, errorThrown) => {
      console.error(`TOPページお知らせ読み込みエラー: ${jqXHR.status}, ${textStatus}, ${errorThrown}`, jqXHR.responseText);
    });
}

/**
 * WP REST API取得JSON型
 */
interface INews {
  id: number;
  title: {
    rendered: string;
  };
  link: string;
  acf: {
    date: Date;
    link_detail: string;
    link_detail_target: boolean;
    archive_display: boolean;
    news_cat: {
      name: string;
    };
  };
}

/**
 * 取得データを表示する
 */
function displayData(data: INews[], target: JQuery): void {
  target.empty();

  let count = 0;
  for (let i = 0; i < data.length; i++) {
    const post = data[i];
    const acf = post.acf;
    const title = post.title.rendered;
    const link_detail = acf.link_detail;
    let url = post.link;
    let _blank = '_self';

    if (link_detail) {
      url = link_detail;
      if (acf.link_detail_target) {
        _blank = '_target';
      }
    }

    if (acf.archive_display && count < 3) {
      const html = /*HTML*/ `
        <a href="${url}" target="${_blank}">
          <span><time>${acf.date}</time><b>${acf.news_cat.name}</b></span>
          <p class="tn-txt">${title}</p>
        </a>
    `;
      count++;
      target.append(html);
    }
  }
}
